module.exports = __webpack_public_path__ + "media/acacia-wilderness-video.55765e3e.mp4";